<div
  class="relative flex"
  [ngClass]="{
    'items-center': !description()
  }"
>
  <div class="relative flex items-center">
    <input
      type="radio"
      [id]="id()"
      [value]="optionValue()"
      (change)="handleChange($event)"
      [disabled]="isDisabled()"
      [name]="groupName()"
      [checked]="selectedValue() === optionValue()"
      class="peer form-radio size-4 cursor-pointer appearance-none rounded-full border border-brand-primary-pure text-brand-primary-pure transition-all duration-75 checked:border-brand-primary-pure checked:bg-none focus:ring-brand-primary-pure enabled:hover:border-brand-primary-dark disabled:cursor-not-allowed disabled:border-neutral-low-light disabled:text-neutral-low-light"
      [ngClass]="{
        'rounded-full': variant() === 'radio',
        rounded: variant() === 'check'
      }"
    />
    <span
      class="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity duration-75 peer-checked:opacity-100"
      [ngClass]="{
        'size-1.5 rounded-full bg-neutral-hight-light': variant() === 'radio',
        'size-4': variant() === 'check'
      }"
    >
      @if (variant() === 'check') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="white"
          class="size-full"
        >
          <path
            d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"
          />
        </svg>
      }
    </span>
  </div>

  @if (label() || description()) {
    <div class="ml-3 text-sm leading-6">
      @if (label()) {
        <label
          [for]="id()"
          class="font-medium"
          [ngClass]="{
            'cursor-not-allowed text-neutral-low-medium': isDisabled(),
            'text-neutral-low-dark': !isDisabled()
          }"
        >
          {{ label() }}
        </label>
      }

      @if (description()) {
        <p class="mt-1 text-neutral-low-medium">
          {{ description() }}
        </p>
      }
    </div>
  }
</div>
